/**
 * @generated SignedSource<<d936a4879ad96205619572cbffe6aaee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewMenu_menu$data = {
  readonly currencySelectionHeader: string | null | undefined;
  readonly currencySelectionInfo: string | null | undefined;
  readonly currencySelectionSaveButtonText: string | null | undefined;
  readonly xlsdownloadtext: string | null | undefined;
  readonly " $fragmentType": "PerformanceOverviewMenu_menu";
};
export type PerformanceOverviewMenu_menu$key = {
  readonly " $data"?: PerformanceOverviewMenu_menu$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewMenu_menu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceOverviewMenu_menu",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "xlsdownloadtext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencySelectionInfo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencySelectionHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencySelectionSaveButtonText",
      "storageKey": null
    }
  ],
  "type": "PerformanceOverviewMenu",
  "abstractKey": null
};

(node as any).hash = "d9167cada787a54dbff85af77104eb82";

export default node;
